module.exports = __webpack_public_path__ + "img/s2.17b4bc7b.jpg";